export default "__VITE_ASSET__evotCQCz__"